import React, { useEffect, useRef, useState } from 'react';
import CustomThumbnailBar from './CustomThumbnailBar';

const CustomSlider2 = ({
  className,
  banners,
  interval = 3000,
  showSlideCount = 1,
  showPrevBtn = 1,
  showNextBtn = 1,
  onItemClick, // thêm prop mới
}) => {
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [isPause, setIsPause] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [preventClick, setPreventClick] = useState(false);

  const slideCount = banners.length;

  // Auto-slide
  useEffect(() => {
    const slideInterval = setInterval(() => {
      if (slideCount > 1 && !isPause) nextSlide();
    }, interval);
    return () => clearInterval(slideInterval);
  }, [current, slideCount, interval, isPause]);

  const prevSlide = () => {
    setIsTransitioning(true);
    setCurrent((prev) => (prev - 1 + slideCount) % slideCount);
  };

  const nextSlide = () => {
    setIsTransitioning(true);
    setCurrent((prev) => (prev + 1) % slideCount);
  };

  // Touch handlers
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.touches[0].clientX);
    setPreventClick(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  // Mouse handlers
  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.clientX);
    setPreventClick(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  // Xử lý click vào ảnh/video
  const handleItemClick = (index, e) => {
    if (!preventClick && onItemClick) {
      onItemClick(index, e);
    }
  };

  return (
    <div
      className={className}
      style={{ position: 'relative', overflow: 'hidden' }}
      ref={sliderRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseMove={(e) => {
        handleMouseMove(e);
        setIsPause(true);
      }}
      onMouseLeave={(e) => {
        if (isDragging) handleMouseUp(e);
        setIsPause(false);
      }}
    >
      {/* Số thứ tự slide */}
      <div
        className='slide-count'
        style={{
          position: 'absolute',
          top: 10,
          left: 10,
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          padding: '2px 8px',
          borderRadius: 6,
          fontSize: 14,
          zIndex: 2,
          display: showSlideCount === 1 ? 'block' : 'none',
        }}
      >
        {current + 1}/{slideCount}
      </div>

      {/* Slider track */}
      <div
        className="slider-track"
        style={{
          display: 'flex',
          transition: isTransitioning ? 'transform 0.4s ease' : 'none',
          transform: `translateX(calc(-${current * 100}% + ${translateX}px))`,
          height: '100%',
        }}
      >
        {banners.map((banner, index) => {
          const isActive = index === current;
          const src = banner.image || banner; // hỗ trợ cả {image: "..."} hoặc string
          return src?.match(/\.(mp4|webm|ogg)$/i) ? (
            <div
              key={index}
              style={{
                minWidth: '100%',
                width: '100%',
                position: 'relative',
                zIndex: isActive ? 3 : 1,
                transition: 'transform 0.3s ease',
                overflow: 'hidden',
              }}
            >
              <video
                className='product-one-img'
                src={src}
                controls
                style={{
                  minWidth: '100%',
                  width: '100%',
                  minHeight: '300px',
                  position: 'relative',
                  transition: 'transform 0.3s ease',
                }}
                onClick={(e) => handleItemClick(index, e)}
              />
            </div>
          ) : (
            <div
              key={index}
              style={{
                minWidth: '100%',
                width: '100%',
                position: 'relative',
                zIndex: isActive ? 3 : 1,
                transition: 'transform 0.3s ease',
                overflow: 'hidden',
              }}
            >
              <img
                className='product-one-img'
                src={src}
                alt={`img_${index}`}
                style={{
                  minWidth: '100%',
                  width: '100%',
                  minHeight: '300px',
                  position: 'relative',
                  zIndex: isActive ? 3 : 1,
                  transition: 'transform 0.3s ease',
                }}
                onClick={(e) => handleItemClick(index, e)}
              />
            </div>
          );
        })}
      </div>

      {/* Nút điều hướng */}
      <button
        onClick={prevSlide}
        style={{
          position: 'absolute',
          top: '50%',
          left: 10,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: 30,
          height: 30,
          fontSize: 18,
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          opacity: 0.5,
          display: showPrevBtn === 1 ? 'flex' : 'none',
        }}
      >
        &lt;
      </button>

      <button
        onClick={nextSlide}
        style={{
          position: 'absolute',
          top: '50%',
          right: 10,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: 30,
          height: 30,
          fontSize: 18,
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          opacity: 0.5,
          display: showNextBtn === 1 ? 'flex' : 'none',
        }}
      >
        &gt;
      </button>

      {/* Thumbnails */}
      <CustomThumbnailBar
        banners={banners}
        current={current}
        onSelect={(index) => setCurrent(index)}
      />
    </div>
  );
};

export default CustomSlider2;